// extracted by mini-css-extract-plugin
export var footer = "_k6-0";
export var inherit = "_k6-1";
export var input = "_k6-2";
export var modalContent = "_k6-3";
export var quillEditor = "_k6-4";
export var subtitle = "_k6-5";